/** The store's price for one of its own private products (flag `store_browser_all_synced`). */
export interface OwnProductPrice {
  price?: number;
  priceFormatted?: string;
  pricing?: {
    msrp?: number;
    map?: number;
    instantRebate?: number | null;
    rebateStartAt?: string | null;
    rebateEndAt?: string | null;
  };
}

const positive = (value: unknown) => Number(value) > 0;

interface PricedRow {
  price?: unknown;
  priceFormatted?: unknown;
  pricing?: object | null;
}

/**
 * A browser row with its own price filled in where it has none, by the server's rule
 * (`withOwnProductPricing`): a value the product carries is never replaced, and a MAP
 * from the sheet comes with the sheet's own rebate and window.
 */
export function withOwnProductPrice<T extends PricedRow>(row: T, own: OwnProductPrice | undefined): T {
  if (!own) return row;
  const current = (row.pricing || {}) as Record<string, unknown>;
  const pricing: Record<string, unknown> = { ...current };
  if (!positive(current.msrp) && own.pricing?.msrp) pricing.msrp = own.pricing.msrp;
  if (!positive(current.map) && own.pricing?.map) {
    pricing.map = own.pricing.map;
    pricing.instantRebate = own.pricing.instantRebate ?? undefined;
    pricing.rebateStartAt = own.pricing.rebateStartAt ?? undefined;
    pricing.rebateEndAt = own.pricing.rebateEndAt ?? undefined;
  }
  const hasPrice = !positive(row.price) && positive(own.price);
  return {
    ...row,
    pricing,
    ...(hasPrice ? { price: own.price, priceFormatted: own.priceFormatted } : {}),
  } as T;
}
